import { usdFormatter } from "../../../functions/currency";

export function getValidPrice(price: number | null | undefined): number | null {
  return isValidPrice(price) ? price : null;
}

function isValidPrice(price: number | null | undefined): price is number {
  return (
    typeof price === "number" &&
    Number.isFinite(price) &&
    price >= 0
  );
}

export function getFormattedPrice(
  price: number | null | undefined,
  formatPrice?: (amount: number) => string,
): string {
  if (price == null) return "—";
  if (isValidPrice(price)) {
    return formatPrice ? formatPrice(price) : usdFormatter.format(price);
  }
  return "Call for Price";
}
